import { z } from "zod";

export const bankInformationSchema = z.object({
  payment_method_name: z
    .string({
      message: "Payment Method Name is required",
    })
    .nonempty({
      message: "Payment Method Name is required",
    }),
  // This is actually phone number
  description: z
    .union([z.string(), z.number()])
    .transform((val) => val.toString())
    .refine((val) => val.length > 0, {
      message: "Phone number cannot be empty",
    }),
  status: z.union([z.string(), z.number()]).nullable().optional(),
});

export type ZBankInformation = z.infer<typeof bankInformationSchema>;
